// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1173":"css/admin-app.6879","6189":"css/app.6879"}[chunkId] + ".css";
};